module.exports = __webpack_public_path__ + "img/bassic-badge.d16434e3.svg";